// Blog posts live as JSON files in this folder; order.json lists the slugs from newest to oldest.
// The blog is reachable from search engines (sitemap) only; nothing in the site navigation links to it.
const context = require.context('./', false, /^\.\/(?!order\.json$).+\.json$/);
const order = require('./order.json');

const bySlug = {};
context.keys().forEach((key) => {
    const post = context(key);
    bySlug[post.slug] = post;
});

export const posts = order.map((slug) => bySlug[slug]).filter(Boolean);
export const getPost = (slug) => bySlug[slug];
